__turbopack_context__.v({
  "button": "FileUploadAddImage-module-scss-module__odLHfG__button",
  "input": "FileUploadAddImage-module-scss-module__odLHfG__input",
});
